export interface AvailablePurchaseUnit {
  id: string
  availableQuantity: number
}

/** Plans concrete units; never puts multiple complete groups in one group ID. */
export function initialPurchaseQuantities(
  units: readonly AvailablePurchaseUnit[],
  preferredId: string,
  minimum: number,
  maximum: number = Number.POSITIVE_INFINITY,
  required = true
): Array<{ id: string, quantity: number }> | null {
  const target = Math.min(Math.max(minimum, 1), maximum)
  if (required && target < minimum) return null
  let remaining = target
  const ordered = [...units].sort((a, b) => Number(b.id === preferredId) - Number(a.id === preferredId))
  const result: Array<{ id: string, quantity: number }> = []
  for (const unit of ordered) {
    const quantity = Math.min(Math.max(0, unit.availableQuantity), remaining)
    if (quantity > 0) result.push({ id: unit.id, quantity })
    remaining -= quantity
    if (remaining === 0) break
  }
  return remaining > 0 && required ? null : result.length ? result : null
}
